import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import { selectOverlapModalState } from '../../../redux/appointmentForm/selectors';
import * as createVirtualVisit from '../../../redux/appointmentForm/requests/create-virtual-visit-req';
import { overlapModalActions } from '../../../redux/appointmentForm/overlap-modal';
import styles from './styles.styl';

const mapStateToProps = state => ({
  isOpenOverlapModal: selectOverlapModalState(state),
});

const mapDispatchToProps = {
  closeModal: overlapModalActions.close,
  initOverlap: createVirtualVisit.actions.overlap,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/VirtualVisit/OverlapModal/enhance.js